export const inheritedGuidanceLabel = (name: string | null | undefined) =>
    name?.trim() ? `Inherited from ${name}` : "Inherited guidance";
